"use client";

import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

const navigation = createNavigation(routing);

// Strict, typed exports (only includes routes declared in `i18n/routing.ts`).
export const StrictLink = navigation.Link;
export const strict_redirect = navigation.redirect;
export const strict_usePathname = navigation.usePathname;
export const strict_useRouter = navigation.useRouter;
export const strict_getPathname = navigation.getPathname;

// Loose exports (accept any internal/external href) while still using next-intl at runtime.
// This avoids having to enumerate every single route in `routing.pathnames`.
export const Link = navigation.Link as any;
export const redirect = navigation.redirect as any;
export const usePathname = navigation.usePathname as any;
export const useRouter = navigation.useRouter as any;
export const getPathname = navigation.getPathname as any;